// Helper class for handling JWT authentication with the web API
import axios from "axios";
var qs = require('qs');
import buefy from 'buefy';

// global 401 error code handler
axios.interceptors.response.use(function (response) {
    // default behavior
    return response;
}, function (error) {

    if (error.response && error.response.status === 401) {
        // JWT token has expired; redirect to login page
        window.location = Apollo.resolveAppUrl("~");
    }

    return Promise.reject(error);
});

var ApiAuth = {
    authenticated: false,

    // call this to update the `authenticated` property
    // returns true if the user has authenticated
    checkAuth: function () {
        var jwtToken = localStorage.getItem("jwt_token");

        if (jwtToken) {
            this.authenticated = true;
        }
        else {
            this.authenticated = false;
        }

        return this.authenticated;
    },

    logout: function () {
        var headers = {
            Accept: "application/json"
        };
        this.addAuthHeader(headers);
        axios.defaults.headers.common = headers;
        axios.post(Apollo.resolveApiUrl("~/auth/logout"));
        localStorage.removeItem("jwt_token");
        document.cookie = this.formatCookie("");
    },

    login: function (credentials, onSuccess, onError) {
        var me = this;

        // we need to add this for JWT OWIN middleware
        credentials.grant_type = "password";

        var config = {
            headers: { 'content-type': 'application/x-www-form-urlencoded;charset=utf-8'}
       
        };
        axios.defaults.headers.common = { Accept: "application/json, text/plain, */*" };
        
        console.log(axios.defaults.headers.common);
        axios.post(
            Apollo.resolveApiUrl("~/token"), qs.stringify(credentials, config)).then(function (res) {
                // build cookie for JWT token
                let cookie = me.formatCookie(res.data.access_token);
                console.log(cookie);
                document.cookie = cookie;

                localStorage.setItem("jwt_token", res.data.access_token);
                me.authenticated = true;
                onSuccess();
                //window.location = Apollo.resolveAppUrl("~/claims/");
            }).catch(error => {
                var response = error.response;

                console.log("error", JSON.stringify(error));

                if (response && response.data.error == "User is banned") {
                    onError("user_banned");
                }
                else if (response && response.status == 400) {
                    onError("invalid_credentials");
                }
                else {
                    if (window.location.href.includes("localhost")) {
                        console.log("Note that when running locally, CORS restrictions prevent the correct error code from returning from the server on login.");
                        console.log("You are most likely not encountering an actual CORS error :)");
                    }

                    onError("login_error");
                }                
            });
    },
    saveToken: function (token) {
        localStorage.setItem("jwt_token", token);
        let cookie = this.formatCookie(token);
        document.cookie = cookie;
        this.authenticated = true;
    },
    getAuthHeader: function () {
        return {
            Authorization: "Bearer " + localStorage.getItem("jwt_token")
        };
    },

    formatCookie: function (token) {
        let cookie = "token=" + token;
        cookie += ";domain=" + document.domain;
        cookie += ";path=" + Apollo.resolveAppUrl("~");
        cookie += ";SameSite=strict";

        // uncomment to allow cookies only over HTTPS
        // cookie += ";Secure";

        return cookie;
    },

    addAuthHeader: function (headers) {
        headers.Authorization = "Bearer " + localStorage.getItem("jwt_token");
    }
};

export default ApiAuth;



// WEBPACK FOOTER //
// ./src/models/ApiAuth.js